import React, { useEffect } from "react";
import WhatWeDo from "./WhatWeDo";
import MakeAnImpact from "./MakeAnImpact";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Donate.css";

function Donate() {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <div>
      <h1 className="donate" data-aos="fade-down">
        <span className="donate-title-text">Support Our Mission</span>
      </h1>
      <MakeAnImpact />
      <hr />
      <WhatWeDo />
    </div>
  );
}

export default Donate;